import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { OperationType } from '../../../../types/dashboard.types';
import { useTheme } from '../../../theme/ThemeProvider';
import Card from '../../../components/ui/Card/Card';
import { operationPalette, tooltipStyle, tooltipText } from '../chartTheme';
import styles from './OperationTypeCard.module.css';

interface OperationTypeCardProps {
  data?: OperationType[];
}

const OperationTypeCard: React.FC<OperationTypeCardProps> = ({ data = [] }) => {
  const { resolvedTheme } = useTheme();

  const chartData = data.map((op, i) => ({
    name: op.operation_type,
    value: op.total_loads,
    color: operationPalette[i % operationPalette.length],
  }));

  return (
    <Card>
      <div className={styles.donutWrap}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              innerRadius={52}
              outerRadius={80}
              paddingAngle={2}
              stroke="none"
            >
              {chartData.map((entry, i) => (
                <Cell key={i} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              contentStyle={tooltipStyle(resolvedTheme)}
              labelStyle={tooltipText(resolvedTheme)}
              itemStyle={tooltipText(resolvedTheme)}
              wrapperStyle={{ zIndex: 10 }}
            />
          </PieChart>
        </ResponsiveContainer>
        <div className={styles.centerLogo}>
          <img src="/dylo-symbol.svg" alt="" />
        </div>
      </div>

      <h4 className={styles.legendTitle}>Administrative Metrics</h4>
      <p className={styles.legendSub}>Loads by Operation Type</p>
      <div className={styles.legend}>
        {chartData.map((entry) => (
          <div key={entry.name} className={styles.legendItem}>
            <span className={styles.dot} style={{ background: entry.color }} />
            {entry.name} ({entry.value})
          </div>
        ))}
      </div>
    </Card>
  );
};

export default OperationTypeCard;
